import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";

// NOTE: Service Worker registration removed
// OneSignal SDK (loaded via CDN in index.html) handles its own service worker registration
// The OneSignalSDKWorker.js file in /public is automatically registered by OneSignal
// This prevents conflicts between multiple service workers

// CRITICAL: Set up service worker message listener IMMEDIATELY
// This must be done before React renders to ensure we catch all messages
if ('serviceWorker' in navigator) {
  console.log('🔧 Setting up service worker message listener in main.tsx');

  // Handler function for service worker messages
  const handleServiceWorkerMessage = async (event: MessageEvent) => {
    console.log('📨 Message from Service Worker (main.tsx):', event.data);
    console.log('📨 Message type:', typeof event.data, 'Keys:', event.data ? Object.keys(event.data) : 'null');
    console.log('📨 Full message data:', JSON.stringify(event.data, null, 2));

    // Handle water logged messages from OneSignal notifications
    if (event.data && event.data.type === 'WATER_LOGGED') {
      console.log('💧 Water logged from notification (main.tsx):', event.data.volume);
      console.log('💧 Full event data:', JSON.stringify(event.data, null, 2));

      // Dispatch custom event for app to handle (for UI updates, query invalidation, etc.)
      // Note: Using 'waterLogged' (camelCase) to match existing event listeners
      const customEvent = new CustomEvent('waterLogged', {
        detail: {
          volume: event.data.volume,
          source: event.data.source || 'notification',
          result: event.data.result,
          deadlineReset: event.data.deadlineReset,
          waterLog: event.data.waterLog
        }
      });

      console.log('🚀 Dispatching waterLogged event:', customEvent.detail);
      window.dispatchEvent(customEvent);
      console.log('✅ waterLogged event dispatched');
    } else {
      console.log('⚠️ Message received but not WATER_LOGGED type:', event.data?.type || 'no type');
    }

    // Handle log water requests from service worker notification action buttons
    if (event.data && event.data.type === 'LOG_WATER_FROM_NOTIFICATION') {
      console.log('💧 Logging water from notification action button:', event.data.volume);

      // Import and call the API
      import('@/services/oneSignalService').then(({ logWaterFromNotificationAction }) => {
        logWaterFromNotificationAction(event.data.volume)
          .then(() => {
            console.log('✅ Water logged successfully from notification');
            // Dispatch event to update UI
            window.dispatchEvent(new CustomEvent('waterLogged', {
              detail: {
                volume: event.data.volume,
                source: 'notification',
              }
            }));
          })
          .catch(error => {
            console.error('❌ Failed to log water from notification:', error);
          });
      });
    }
  };

  // Register the message listener
  navigator.serviceWorker.addEventListener('message', handleServiceWorkerMessage);

  // CRITICAL: Also listen for messages from the controller (active service worker)
  // This ensures we receive messages even if the service worker is already active
  navigator.serviceWorker.ready.then((registration) => {
    console.log('✅ Service worker ready, controller:', registration.active?.scriptURL);
  });

  console.log('✅ Service worker message listener registered in main.tsx');
} else {
  console.warn('⚠️ Service Worker not supported or not in secure context');
}

createRoot(document.getElementById("root")!).render(<App />);
